interface IServerConfig {
  isDebugMode: boolean;
  isDevelopment: boolean;
  stack9Token: string;
  stack9Url: string;
  recaptchaKey: string;

  pbiClientId: string;
  pbiClientSecret: string;
  pbiTenantId: string;

  // siteUrl: string;
  // authClientId: string;
  // authClientSecret: string;
  // authTenantName: string;
  // authTenantId: string;
  // jwtSecret: string;
  // jwtUserFlow: string;

  auth: {
    daysPasswordChangeExpiry: string;
    cookieTime: string;
    secretToken: string;

    azuread: {
      tenantId: string;
      identityMetadata: string;
      clientID: string;
      responseType: string;
      responseMode: string;
      redirectUrl: string;
      allowHttpForRedirectUrl: boolean;
      clientSecret: string;
      validateIssuer: boolean;
      isB2C: boolean;
      issuer: string | null;
      passReqToCallback: boolean;
      useCookieInsteadOfSession: boolean;
      cookieEncryptionKeys: any;
      scope: string[];
      loggingLevel: string;
      nonceLifetime: string | null;
      nonceMaxAmount: number;
      clockSkew: string | null;
      destroySessionUrl: string;
    };
  };
}

// if (process.browser) {
//   throw new Error('do not import this client side.');
// }

export default {
  isDebugMode: process.env.DEBUG_MODE === 'true',
  isDevelopment: process.env.NODE_ENV === 'development',
  stack9Token: process.env.STACK9_API_TOKEN,
  stack9Url: process.env.STACK9_API_URL,
  recaptchaKey: process.env.GOOGLE_RECAPTCHA_SECRET_KEY,

  pbiClientId: process.env.PBI_CLIENT_ID,
  pbiClientSecret: process.env.PBI_CLIENT_SECRET,
  pbiTenantId: process.env.PBI_TENANT_ID,

  auth: {
    daysPasswordChangeExpiry: process.env.AUTH_DAYS_PASSWORD_CHANGE_EXPIRY,
    cookieTime: process.env.AUTH_COOKIE_TIME,
    secretToken: process.env.AUTH_SECRET_TOKEN,

    azuread: {
      tenantId: process.env.AUTH_TENANT_ID,
      // Required
      // identityMetadata: 'https://login.microsoftonline.com/<tenant_name>.onmicrosoft.com/.well-known/openid-configuration',
      identityMetadata:
        'https://login.microsoftonline.com/common/.well-known/openid-configuration',

      // or equivalently: 'https://login.microsoftonline.com/<tenant_guid>/.well-known/openid-configuration'
      //
      // or you can use the common endpoint
      // 'https://login.microsoftonline.com/common/.well-known/openid-configuration'
      // To use the common endpoint, you have to either set `validateIssuer` to false, or provide the `issuer` value.

      // Required, the client ID of your app in AAD
      clientID: process.env.AUTH_CLIENT_ID,

      // Required, must be 'code', 'code id_token', 'id_token code' or 'id_token'
      responseType: 'code id_token',

      // Required
      responseMode: 'form_post',

      // Required, the reply URL registered in AAD for your app
      redirectUrl: process.env.AUTH_REDIRECT_URL,

      // Required if we use http for redirectUrl
      allowHttpForRedirectUrl: true,

      // Required if `responseType` is 'code', 'id_token code' or 'code id_token'.
      // If app key contains '\', replace it with '\\'.
      clientSecret: process.env.AUTH_CLIENT_SECRET,

      // Required to set to false if you don't want to validate issuer
      validateIssuer: false,

      // Required to set to true if you are using B2C endpoint
      // This sample is for v1 endpoint only, so we set it to false
      isB2C: false,

      // Required if you want to provide the issuer(s) you want to validate instead of using the issuer from metadata
      issuer: null,

      // Required to set to true if the `verify` function has 'req' as the first parameter
      passReqToCallback: true,

      // Recommended to set to true. By default we save state in express session, if this option is set to true, then
      // we encrypt state and save it in cookie instead. This option together with { session: false } allows your app
      // to be completely express session free.
      useCookieInsteadOfSession: false,

      // Required if `useCookieInsteadOfSession` is set to true. You can provide multiple set of key/iv pairs for key
      // rollover purpose. We always use the first set of key/iv pair to encrypt cookie, but we will try every set of
      // key/iv pair to decrypt cookie. Key can be any string of length 32, and iv can be any string of length 12.
      cookieEncryptionKeys: [
        {
          key: process.env.COOKIE_ENCRYPTION_MAIN_KEY,
          iv: process.env.COOKIE_ENCRYPTION_MAIN_IV,
        },
        {
          key: process.env.COOKIE_ENCRYPTION_SECONDARY_KEY,
          iv: process.env.COOKIE_ENCRYPTION_SECONDARY_IV,
        },
      ],

      // Optional. The additional scope you want besides 'openid', for example: ['email', 'profile'].
      scope: ['email', 'profile'],

      // Optional, 'error', 'warn' or 'info'
      loggingLevel: 'info',

      // Optional. The lifetime of nonce in session or cookie, the default value is 3600 (seconds).
      nonceLifetime: null,

      // Optional. The max amount of nonce saved in session or cookie, the default value is 10.
      nonceMaxAmount: 5,

      // Optional. The clock skew allowed in token validation, the default value is 300 seconds.
      clockSkew: null,

      destroySessionUrl:
        'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=http://localhost:3333',
    },
  },
} as IServerConfig;
